import React, { useEffect, useState } from 'react';
import { Box, Container, Heading, Input, Image, Button, Text, Label } from 'theme-ui';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { setLoader } from "src/redux/reducers/loadingActionReducer";
import { Redirect } from 'react-router-dom';
import { useDispatch } from "react-redux";
import PndApi from '../../../../../utils/pnd/PndRestApi';
import { jwtDecode } from "jwt-decode";
import logo from '../assets/logo.png';
import header from '../assets/Header_Website.png';
import Alert from './alert';
import './banner.css'
import packageJson from '../../../../../../package.json'
import { ITCADMIN_ACCOUNT_NO, LOGIN_HUB_USER_IDENTIFIER, LOGIN_ITC_ADMIN_IDENTIFIER, LOGIN_MERCHANT_IDENTIFIER, CLIENT_ADMIN, HUB_OPERATOR_ROLE_ID, ITC_ADMIN_ROLE_ID, HUB_MANAGER_ROLE_ID, MERCHANT_ROLE_ID, SECURITY_ROLE_ID } from 'src/utils/pnd/PndConstants';
import { getOrderPreferences } from 'src/redux/actions/orderPreferencesActions';
import { motion, AnimatePresence } from 'framer-motion';

const Banner = () => {
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isRedirect, setIsRedirect] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [accountNo, setAccountNo] = useState('');

  useEffect(() => {
    const handleEnterKeyPress = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault(); // Prevent default form submission behavior
        handleSubmit();
      }
    };
    document.addEventListener('keydown', handleEnterKeyPress);

    return () => {
      document.removeEventListener('keydown', handleEnterKeyPress); // Cleanup event listener
    };
  }, [accountNo, username, password]);


  useEffect(() => {
    const storedRememberMe = localStorage.getItem('rememberMe');
    if (storedRememberMe === 'true') {
      const storedUsername = localStorage.getItem('username');
      const storedPassword = localStorage.getItem('password');
      const storedAccountNo = localStorage.getItem('accountNo');
      if (storedUsername && storedPassword && storedAccountNo) {
        setUsername(storedUsername);
        setPassword(storedPassword);
        setAccountNo(storedAccountNo);
        setRememberMe(true);
      }
    } else {
      localStorage.setItem('rememberMe', false);
      localStorage.removeItem('username');
      localStorage.removeItem('accountNo');
      localStorage.removeItem('password');
    }

    const isLoggedIn = localStorage.getItem("access_token");
    if (isLoggedIn) {
      const decoded = jwtDecode(isLoggedIn || '');
      if (decoded?.exp) {
        const currentTime = Date.now() / 1000;
        if (decoded.exp > currentTime) {
          setIsRedirect(true);
          return;
        }

      }
    }

  }, [])

  const handleUsernameChange = (value) => {
    setUsername(value)
  }

  const handlePasswordChange = (value) => {
    setPassword(value)
  }

  const handleAccountNumberChange = (value) => {
    setAccountNo(value);
  }

  if (rememberMe) {
    if (username === "" || password === "" || accountNo === "") {
      setErrorMsg(true);
      setErrorMessage('Please fill the required informations');
      setRememberMe(false);
      return;

    } else {
      localStorage.setItem("username", username);
      localStorage.setItem("password", password);
      localStorage.setItem("accountNo", accountNo);
      localStorage.setItem("rememberMe", rememberMe);
    }
  }

  if (isRedirect) {
    if (localStorage.getItem("ut") !== null || localStorage.getItem("ut") !== undefined || localStorage.getItem("ut") !== "") {
      const ut = parseInt(localStorage.getItem("ut"));
      if (
        ut === CLIENT_ADMIN ||
        ut === HUB_OPERATOR_ROLE_ID ||
        ut === ITC_ADMIN_ROLE_ID ||
        ut === HUB_MANAGER_ROLE_ID ||
        ut === MERCHANT_ROLE_ID ||
        ut === SECURITY_ROLE_ID
      ) {
        return <Redirect to="/web_app/dashboard/pnd_default_dashboard" />;
      }
    }

  }

  const handleSubmit = async () => {
    if (!accountNo.trim()) {
      setErrorMsg(true);
      setErrorMessage('Please enter Account No.');
      return;
    }

    if (!username.trim() || !password.trim()) {
      setErrorMsg(true);
      setErrorMessage('Please enter both Username and Password.');
      return;
    }

    try {
      const token = await executeRecaptcha("login"); // Execute reCAPTCHA for "login" action
      if (!token) {
        setErrorMsg(true);
        setErrorMessage('Failed to verify reCAPTCHA. Please try again.');
        return;
      }

      let formData = new FormData();
      if (accountNo !== "" || accountNo !== null || accountNo !== undefined) {

        if (accountNo == ITCADMIN_ACCOUNT_NO) { /** ITCADMIN */
          formData.append('username', username);   //append the values with key, value pair
          formData.append('password', password);
          formData.append('accountNumber', ITCADMIN_ACCOUNT_NO);
          formData.append('userType', LOGIN_ITC_ADMIN_IDENTIFIER);
        }
        if (accountNo.startsWith("M")) { /** MERCHANT */

          formData.append('username', username);   //append the values with key, value pair
          formData.append('password', password);
          formData.append('accountNumber', accountNo);
          formData.append('userType', LOGIN_MERCHANT_IDENTIFIER);

        }
        else { /** Hub User */
          formData.append('username', username);
          formData.append('password', password);
          formData.append('accountNumber', accountNo);
          formData.append('userType', LOGIN_HUB_USER_IDENTIFIER);
        }
      }

      if (formData && formData !== null) {
        dispatch(setLoader(true));
        const response = await PndApi.Login(formData);
        if(response==null||response==undefined){
          console.log("No response from server");
        }else{
          console.log("login response from server",response);
        }
        if (!response) {
          setErrorMessage('Internal server error. Please contact your admin or try again later.');
          dispatch(setLoader(false));
          setErrorMsg(true);
          return;
        }

        if (response?.data?.status === 401 || response?.data?.status === 402) {
          setErrorMessage(response.data.message);
          dispatch(setLoader(false));
          setErrorMsg(true);
          return;
        }

        if (response?.status === 200 && response?.data?.status === 200) {
          localStorage.setItem("access_token", response.data?.data?.access_token || '');
          localStorage.setItem("refresh_token", response.data?.data?.refresh_token || '');
          const decoded = jwtDecode(response.data?.data?.access_token || '');
          if (decoded.ut) localStorage.setItem("ut", decoded.ut);
          if (decoded.ci) localStorage.setItem("ci", decoded.ci);
          if (decoded.ui) localStorage.setItem("ui", decoded.ui);
          if (decoded.uri) localStorage.setItem("uri", decoded.uri);
          if (decoded.hi) localStorage.setItem("hi", decoded.hi);
          if (decoded.mi) localStorage.setItem("mi", decoded.mi);
          dispatch(getOrderPreferences());
          setIsRedirect(true);
        } else {
          setErrorMessage('Authentication failed. Please try again.');
        }
      } else {
        setErrorMessage('Some of the required parameters are missing. Please try again.');
      }
    } catch (error) {
      console.error("Error:", error);
      if (error?.response?.data?.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('Internal server error. Please contact your admin or try again later.');
      }
    } finally {
      dispatch(setLoader(false));
      setErrorMsg(true);
    }

  };

  return (
    <div className="row-banner" style={{ background: 'linear-gradient(135deg, #e0f7fa 0%, #ffffff 100%)' }}>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="half banner-image-section"
          style={{
            position: 'relative',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'url(' + header + ') no-repeat center center',
            backgroundSize: 'contain',
            backgroundColor: '#B8E8D2'
          }}
        >
          {/* 
                Original IMG tag was here. Replaced with background image for cleaner layout or keep if preferred.
                Keeping original layout structure roughly but enhancing with animation.
             */}
          <div className="section" style={{ width: '100%', height: '100%' }}>
            {/* Original Img logic if needed, but background approach often cleaner for 'banner' sections */}
            <Image src={header} sx={{ width: '80%', height: 'auto', display: 'none' }} />

            <Heading
              as="h1"
              sx={{
                textAlign: 'start',
                fontFamily: 'ProductSansLight',
                fontSize: 14,
                color: '#0D1E1C',
                position: 'absolute',
                bottom: 20,
                left: 20,
                opacity: 0.7
              }}
            >
              App Version {packageJson.version}
            </Heading>
          </div>
        </motion.div>
      </AnimatePresence>

      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className="half banner-form-section"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)'
        }}
      >
        <div style={{ width: '100%', maxWidth: '450px', padding: '40px', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.08)', backgroundColor: '#fff' }}>
          <div style={{ position: 'absolute', top: 20, left: 0, right: 0, padding: '0 20px', zIndex: 10 }}>
            {errorMsg && <Alert type={'error'} message={errorMessage} />}
          </div>

          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Image src={logo} sx={{ width: '120px', height: 'auto', mb: 3 }} />
            <Heading as="h1" sx={{ fontFamily: 'ProductSansBold', fontSize: [4, 5], color: '#0D1E1C', mb: 2 }}>
              Welcome Back !
            </Heading>
            <Text sx={{ color: '#666', fontSize: 2 }}>
              Manage Pick and Drop orders with ease
            </Text>
          </Box>

          <Box as="form" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
            <Box sx={{ mb: 3 }}>
              <Input
                onChange={(e) => handleAccountNumberChange(e.target.value)}
                value={accountNo}
                placeholder='Account No.'
                sx={styles.modernInput}
              />
            </Box>
            <Box sx={{ mb: 3 }}>
              <Input
                onChange={(e) => handleUsernameChange(e.target.value)}
                value={username}
                placeholder='Username'
                sx={styles.modernInput}
              />
            </Box>
            <Box sx={{ mb: 3, position: 'relative' }}>
              <Input
                type={showPassword ? 'text' : 'password'}
                onChange={(e) => handlePasswordChange(e.target.value)}
                value={password}
                placeholder='Password'
                sx={styles.modernInput}
              />
              <Box
                onClick={togglePasswordVisibility}
                sx={{
                  position: 'absolute',
                  right: '15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#999',
                  '&:hover': { color: '#11B268' }
                }}
              >
                {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
              </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
              <Label sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', userSelect: 'none' }}>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => {
                    const newValue = !rememberMe;
                    setRememberMe(newValue);
                    if (!newValue) {
                      localStorage.removeItem('username');
                      localStorage.removeItem('password');
                      localStorage.removeItem('accountNo');
                      localStorage.removeItem('rememberMe');
                    }
                  }}
                  style={{ display: 'none' }}
                />
                <Box
                  sx={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '6px',
                    border: '2px solid',
                    borderColor: rememberMe ? '#11B268' : '#e0e0e0',
                    backgroundColor: rememberMe ? '#11B268' : 'transparent',
                    mr: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s'
                  }}
                >
                  {rememberMe &&
                    <Box sx={{ width: '8px', height: '8px', borderRadius: '2px', backgroundColor: '#fff' }} />}
                </Box>
                <Text sx={{ fontSize: 1, color: '#666', fontFamily: 'ProductSansRegular' }}>Remember Me</Text>
              </Label>
              <Text sx={{ fontSize: 1, color: '#11B268', cursor: 'pointer', fontFamily: 'ProductSansBold', '&:hover': { textDecoration: 'underline' }, whiteSpace: 'nowrap' }}>
                Forgot Password?
              </Text>
            </Box>

            <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
              <Button
                type="submit"
                sx={{
                  width: '100%',
                  bg: '#11B268',
                  color: '#fff',
                  py: 3,
                  borderRadius: '12px',
                  fontSize: 3,
                  fontFamily: 'ProductSansBold',
                  cursor: 'pointer',
                  boxShadow: '0 10px 20px rgba(17, 178, 104, 0.2)',
                  transition: 'all 0.3s',
                  '&:hover': {
                    bg: '#0D9E59',
                    boxShadow: '0 15px 25px rgba(17, 178, 104, 0.3)',
                  }
                }}
              >
                Log In
              </Button>
            </motion.div>
          </Box>
          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Text sx={{ color: '#666', fontSize: 1, fontFamily: 'ProductSansRegular' }}>
              Don't have an account?{' '}
              <a
                href="https://informapuae.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#11B268', fontWeight: 'bold', textDecoration: 'none', cursor: 'pointer' }}
              >
                Sign Up
              </a>
            </Text>
          </Box>
        </div>
      </motion.div>
    </div>
  );
};


export default Banner;

const styles = {
  modernInput: {
    width: '100%',
    padding: '16px',
    borderRadius: '12px',
    border: '2px solid transparent',
    backgroundColor: '#f5f7fa',
    fontFamily: 'ProductSansRegular',
    fontSize: '16px',
    color: '#333',
    transition: 'all 0.3s ease',
    '&:focus': {
      outline: 'none',
      backgroundColor: '#fff',
      borderColor: '#11B268',
      boxShadow: '0 0 0 4px rgba(17, 178, 104, 0.1)'
    },
    '&::placeholder': {
      color: '#a0a0a0'
    }
  }
};
